import { MinusCircleMultipleIcon } from './MinusCircleMultipleIcon';

/**
 * author: Michael Irigoyen
 * id C7561067-F057-4E26-B8F1-791BD24E0A2C
 * name minus-circle-multiple
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/minus-circle-multiple.svg
 * tags
 * - Form 
 */
export const CoinsMinusIcon = MinusCircleMultipleIcon;
export default CoinsMinusIcon